var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNurseassistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4963_4344)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4286 4.28571C11.4286 5.42236 10.977 6.51244 10.1733 7.31617C9.36959 8.1199 8.2795 8.57143 7.14286 8.57143C6.00622 8.57143 4.91613 8.1199 4.1124 7.31617C3.30867 6.51244 2.85714 5.42236 2.85714 4.28571C2.85714 3.14907 3.30867 2.05898 4.1124 1.25526C4.91613 0.451529 6.00622 0 7.14286 0C8.2795 0 9.36959 0.451529 10.1733 1.25526C10.977 2.05898 11.4286 3.14907 11.4286 4.28571ZM13.4371 9.28571C13.2477 9.28571 13.066 9.36097 12.9321 9.49492C12.7981 9.62888 12.7229 9.81056 12.7229 10V12.7229H10C9.81056 12.7229 9.62888 12.7981 9.49492 12.9321C9.36097 13.066 9.28571 13.2477 9.28571 13.4371V15.7586C9.28571 15.948 9.36097 16.1297 9.49492 16.2636C9.62888 16.3976 9.81056 16.4729 10 16.4729H12.7229V19.2857C12.7229 19.4752 12.7981 19.6568 12.9321 19.7908C13.066 19.9247 13.2477 20 13.4371 20H15.7586C15.948 20 16.1297 19.9247 16.2636 19.7908C16.3976 19.6568 16.4729 19.4752 16.4729 19.2857V16.4729H19.2857C19.4752 16.4729 19.6568 16.3976 19.7908 16.2636C19.9247 16.1297 20 15.948 20 15.7586V13.4371C20 13.2477 19.9247 13.066 19.7908 12.9321C19.6568 12.7981 19.4752 12.7229 19.2857 12.7229H16.4729V10C16.4729 9.81056 16.3976 9.62888 16.2636 9.49492C16.1297 9.36097 15.948 9.28571 15.7586 9.28571H13.4371ZM7.14286 10C8.38424 9.99946 9.60434 10.3225 10.6829 10.9371H10C9.33696 10.9371 8.70107 11.2005 8.23223 11.6694C7.76339 12.1382 7.5 12.7741 7.5 13.4371V15.7586C7.5 16.6386 7.95429 17.4114 8.64 17.8571H0.714286C0.524845 17.8571 0.343164 17.7819 0.209209 17.6479C0.0752549 17.514 0 17.3323 0 17.1429C0 15.2485 0.752549 13.4316 2.09209 12.0921C3.43164 10.7525 5.24845 10 7.14286 10Z",
    fill: "#686868"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4963_4344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurseassistant);
export default __webpack_public_path__ + "static/media/nurseassistant.27cce75352d54cedf908ce696293e784.svg";
export { ForwardRef as ReactComponent };